import { useAuthStore, useNotificationsStore, useToastStore } from './modules';

import { useEnhancedAuth, useEnhancedNotifications } from './composables';

export function initializeStores() {
    const authStore = useAuthStore();
    const notificationsStore = useNotificationsStore();
    const toastStore = useToastStore();

    if (authStore.isAuthenticated) {
        notificationsStore.loadNotificationCount();
        notificationsStore.loadRecentNotifications();
    }

    return {
        authStore,
        notificationsStore,
        toastStore
    };
}

export {
    useAuthStore,
    useNotificationsStore,
    useToastStore,
    useEnhancedAuth,
    useEnhancedNotifications
};